<template>
  <div class="product-bg">
    <div
      v-show="loading"
      class="loading"
      style="background-color: white; top: 60px"
    >
      <div class="loading-load">
        <a-spin size="large" tip="loading..." />
      </div>
    </div>
    <div class="product-detail">
      <a-breadcrumb>
        <a-breadcrumb-item>All Products</a-breadcrumb-item>
        <a-breadcrumb-item>{{ productName }}</a-breadcrumb-item>
      </a-breadcrumb>

      <div class="content">
        <div class="imgList">

          <div class="imgList-img">
            <img
              v-for="(item, index) in showImageList"
              :key="index"
              :src="item"
              :class="{ actived: index == imgActived }"
              @click="changeImg(index, item)"
            >
          </div>

        </div>
        <div class="left">
          <!-- <img :src="mainImg"> -->
          <vue-photo-zoom-pro :high-url="mainImg">
            <img class="leftimg" :src="mainImg">
          </vue-photo-zoom-pro>
        </div>
        <div class="right">
          <h1>{{ productName }}</h1>
          <div class="good-top">
            <p v-for="(item, index) in skuMaps" :key="index" class="good-info">
              <span class="tag-span d-flex flex-warp tag-content">
                <span class="tag-name flex-none">{{ item.name }}:</span>
                <a-tag
                  v-for="(item2, itemIndex) in item.items"
                  :key="itemIndex"
                  color="#106ebe"
                  class="cursor"
                >{{ item2.name }}</a-tag>
              </span>
            </p>
          </div>
          <div class="good-bottom">
            <p v-if="favorablePrice" class="good-info">
              <span>
                price:
                <a class="cursor bigfont">
                  ${{ favorablePrice | MoneyFormat }} ~ ${{
                    maxSkuPrice | MoneyFormat
                  }}
                </a>
              </span>
            </p>
            <p v-else class="good-info">
              <span>
                Price:
                <a class="cursor bigfont">
                  ${{ minSkuPrice | MoneyFormat }} ~ ${{
                    maxSkuPrice | MoneyFormat
                  }}
                </a>
              </span>
            </p>
            <p class="good-info">
              <span>
                Shipping:
                <a class="cursor bigfont">
                  ${{ minLogisticsPrice | MoneyFormat }} ~ ${{
                    maxLogisticsPrice | MoneyFormat
                  }}
                </a>
              </span>
            </p>
            <div class="goods-info-operations">
              <a class="cursor" @click="goCustom">Design Now</a>
              <a
                v-if="productType === enums.blankProductTypeEnum.JET.value"
                class="cursor mt5"
                style="background-color: aliceblue;color: #3189cc;border-color: #3189cc;"
                @click="toUploadProduct"
              >Order Designed Mockups</a>

            </div>
          </div>
        </div>
      </div>
      <div class="tab">
        <a-tabs type="card">
          <a-tab-pane key="1" tab="Description">
            <div class="description" v-html="blankDescToC" />
          </a-tab-pane>
          <a-tab-pane key="2" tab="Variants">
            <div v-if="skuLen != 1">
              <div
                v-for="(item, index) in skuArr"
                :key="index"
                class="variants"
              >
                <div style="width:100%">
                  <div class="v-title">
                    <span class="title-btn">{{ item.optionName }}</span>
                    <p class="title-top">{{ item.optionValue }}</p>
                    <span class="title-right">Costs($)</span>
                  </div>
                  <div class="v-table">
                    <div
                      v-for="(item2, index2) in item.children"
                      :key="index2"
                      class="v-list"
                      :class="{ active: item2.isShow == true }"
                    >
                      <div
                        class="v-head clearfix"
                        @click="isShowSize(index, index2)"
                      >
                        <div class="v-head-left">
                          <p class="title-top">{{ item2.optionName }}</p>
                          <p class="title-btn">{{ item2.optionValue }}</p>
                        </div>
                        <div class="v-head-right">
                          <i class="el-icon-arrow-down" />
                          <p
                            v-if="item2.children.length == 0"
                            class="title-price"
                          >
                            ${{ item2.price }}
                          </p>
                        </div>
                      </div>
                      <p v-if="item2.children.length > 0" class="m10">
                        {{ item2.children[0].optionName }}
                      </p>
                      <div class="v-td">
                        <div
                          v-for="(item3, index3) in item2.children"
                          :key="index3"
                        >
                          <div class="v-td-list">
                            <div class="clearfix">
                              <span>{{ item3.optionValue }}</span>
                              <em>${{ item3.price }}</em>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 只有一个的情况 -->
            <div v-if="skuLen == 1" class="variants">
              <div style="width:100%">
                <div class="v-table">
                  <div
                    v-for="(item, index) in skuArr"
                    :key="index"
                    class="v-list"
                  >
                    <div class="v-head clearfix">
                      <div class="v-head-left">
                        <p class="title-top">{{ item.optionName }}</p>
                        <p class="title-btn">{{ item.optionValue }}</p>
                      </div>
                      <div class="v-head-right">
                        <p class="title-price">${{ item.price }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a-tab-pane>
          <a-tab-pane key="3" tab="Shipping rates">
            <div class="shoip">
              <table>
                <thead>
                  <tr>
                    <th class="shipping-text">Shipping to</th>
                    <th class="shipping-price">Standard shipping days</th>
                    <th class="shipping-price">Standard shipping($)</th>
                    <th class="shipping-price">Standard Additional item($)</th>
                    <th class="shipping-price">Fast shipping days</th>
                    <th class="shipping-price">Fast shipping($)</th>
                    <th class="shipping-price">Fast Additional item($)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in shoip" :key="index">
                    <td class="shipping-country shipping-text">
                      {{ item.enName }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.standardTransportDay }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.standardFirstPrice | MoneyFormat('free') }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.standardNextPrice | MoneyFormat('free') }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.expressTransportDay || '-' }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.expressFirstPrice| MoneyFormat('free') }}
                    </td>
                    <td class="shipping-value shipping-price">
                      {{ item.expressNextPrice| MoneyFormat('free') }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </a-tab-pane>
        </a-tabs>
      </div>
      <blankProduct
        v-if="isRouterAlive"
        :recommend-from-product-id="id"
      />
    </div>
  </div>
</template>
<script>
import { productDetail } from '@/api/product'
import blankProduct from '../product/blankProduct'
import blankProductTypeEnum from '@/enums/blank_product/blankProductTypeEnum'
import { mapGetters } from 'vuex'
import vuePhotoZoomPro from 'vue-photo-zoom-pro'
import 'vue-photo-zoom-pro/dist/style/vue-photo-zoom-pro.css'
// import Vue from "vue";
export default {
  name: 'PodDetail',
  components: {
    blankProduct,
    vuePhotoZoomPro
  },
  props: {
    productId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      productDiscount: 1,
      loading: false, // 加载中
      mainImg: '', // 产品主图
      imgActived: 0,
      id: '',
      productName: '',
      productType: null,
      activeName: 'first',
      blankDescToC: '', // 白板描述
      skuInfo: {}, // 白板信息
      skuMaps: [], // sku map列表
      price: 0, // 白板最低价
      favorablePrice: 0, // 优惠价格
      minSkuPrice: 0,
      maxSkuPrice: 0,
      minLogisticsPrice: 0,
      maxLogisticsPrice: 0,
      variant: [],
      variantOne: [],
      sizeName: 'size',
      size: { s: '$10', M: '$10', L: '$10' },
      shoip: [],
      showImageList: [], // 附图列表
      skuLen: '', // 表格的要循环几层
      skuArr: [],
      patternInfos: [],
      enums: {
        blankProductTypeEnum
      },
      isRouterAlive: true // 组件刷新
    }
  },
  computed: {
    ...mapGetters('User', {
      isLogin: 'getIsLogin'
    })
  },
  mounted() {
    this.ssrCountSet(1)
    this.init().finally(() => {
      this.ssrCountDown()
    })
  },
  methods: {
    // 监听路由参数变化
    getId() {
      this.init()
      this.reloadAll()
    },
    reloadAll() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async init() {
      this.loading = true
      this.id = this.productId
      const { data } = await productDetail({
        id: this.id,
        blankProductInfo: true,
        skuInfos: true,
        skuMap: true,
        shippingRateInfos: true,
        showImageList: true,
        blankContent: true,
        blankDescToC: true,
        blankDescToShopify: false,
        blankSpecMetric: false,
        blankSpecImperial: false,
        skuTree: true,
        blankPattern: true
      })
      this.skuArr = data.skuTrees || []
      if (this.skuArr[0]['children'].length === 0) {
        this.skuLen = 1
      }

      this.skuMaps = data.skuMaps || []
      // for(let i = 0; i<this.skuMaps.length; i++){
      //   this.skuMaps1.push();
      // }
      // this.skuMaps1 = data.skuMaps;
      this.showImageList = data.showImageList
      this.mainImg = data.showImageList[0]
      this.blankDescToC = data.blankDescToC
      this.shoip = data.shippingRateInfos
      this.productDiscount = data.blankProductInfo.productDiscount
      this.price = data.blankProductInfo.price
      this.minSkuPrice = data.blankProductInfo.minSkuPrice
      this.maxSkuPrice = data.blankProductInfo.maxSkuPrice
      this.minLogisticsPrice = data.blankProductInfo.minLogisticsPrice
      this.maxLogisticsPrice = data.blankProductInfo.maxLogisticsPrice
      this.favorablePrice = data.blankProductInfo.favorablePrice
      this.productName = data.blankProductInfo.model
      this.productType =
        data.blankProductInfo.type || blankProductTypeEnum.JET.value

      data.patternInfos.forEach(item => {
        item.knifeInfos.forEach(item2 => {
          var param = {}
          param.id = item2.id
          param.url = item2.knifePlateImageUrl
          this.patternInfos.push(param)
          // this.patternInfos.push(item2.id);
        })
      })
      this.loading = false
    },
    // Sku属性大于一种的展开
    isShowSize(index, index2) {
      if (!this.skuArr[index]['children'][index2].isShow) {
        this.skuArr[index]['children'][index2].isShow = true
      } else {
        this.skuArr[index]['children'][index2].isShow = false
      }
      this.$forceUpdate()
    },

    goCustom() {
      if (!this.isLogin) {
        this.callNewPage({
          path: `/login`,
          query: {
            redirect: this.$route.path
          }
        })
        return
      }
      if (this.$route.query.type === '3') {
        this.callNewPage({
          path: '/diyCustom',
          query: {
            id: this.id,
            patternInfos: JSON.stringify(this.patternInfos)
          }
        })
      } else {
        this.callNewPage({
          path: '/Trending',
          query: {
            id: this.id,
            patternInfos: JSON.stringify(this.patternInfos)
          }
        })
      }
    },
    toUploadProduct() {
      this.callNewPage(`/upload_product/${this.productId}`)
    },
    changeImg(index, url) {
      this.imgActived = index
      this.mainImg = url
    },
    _up() {
      if (this.imgActived > 0) {
        this.imgActived = this.imgActived - 1
        this.mainImg = this.showImageList[this.imgActived]
      }
    },
    _down() {
      const len = this.showImageList.length - 1
      if (this.imgActived < len) {
        this.imgActived = this.imgActived + 1
        this.mainImg = this.showImageList[this.imgActived]
      }
    }
  }
}
</script>
<style lang="scss">
.product-detail {
  padding: 0 16px;
  max-width: 1168px;
  margin: 0 auto;
  margin-top: 20px;
  .imgList {
    white-space: nowrap;
    overflow: hidden;
    margin-top: 20px;
    margin-left: 16px;
    width: 79px;
    .imgList-img {
      height: 350px;
      overflow-y: hidden;
      scrollbar-width: none;
      &:hover {
        overflow-y: scroll;
      }
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 2px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 10px;
        box-shadow: inset 0 0 5px #ccc;
        background: #535353;
      }
      &::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 10px;
        background: #ededed;
      }
    }
    .icon {
      font-size: 20px;
      text-align: center;
      cursor: pointer;
    }
    img {
      float: left;
      border: 1px solid #e7e7e7;
      width: 70px;
      height: 70px;
      margin-right: 15px;
      object-fit: cover;
      object-position: center;
      margin-top: 10px;
      cursor: pointer;
      vertical-align: center;
      &.actived {
        border: 1px solid #106ebe;
      }
    }
  }
  .title {
    padding: 0 16px;
    height: 60px;
    margin-bottom: -20px;
    text-align: left;
    a {
      cursor: pointer;
      &:hover {
        color: #106ebe;
      }
    }
    span {
      margin-left: 5px;
    }
  }
  .content {
    display: flex;
    padding: 0 16px;
    margin-top: 20px;
    .left {
      width: 440px;
      height: 440px;
      .leftimg {
        width: 440px;
        height: 440px;
      }
    }
    .right {
      min-width: 0;
      position: relative;
      flex: 1;
      flex-direction: column;
      justify-content: space-between;
      font-weight: 500;
      text-align: left;
      margin-left: 60px;
      h1 {
        font-size: 28px;
        color: #1b1b1b;
        margin-bottom: 25px;
      }
      .good-top {
        min-height: 171px;
      }
      .good-bottom {
        .goods-info-operations a {
          text-decoration: none;
          color: #fff;
          display: inline-block;
          width: 360px;
          height: 50px;
          line-height: 50px;
          background-color: #106ebe;
          color: #fff;
          border-radius: 5px;
          text-align: center;
          cursor: pointer;
        }
      }
      .good-info {
        .tag-span {
          //display: flex;
          width: 400px;
        }
        span {
          font-size: 16px;
          .cursor {
            font-size: 12px;
            cursor: pointer;
            margin-left: 7px;
          }
          .bigfont {
            font-size: 24px;
            font-weight: bold;
          }
        }
        .tag-name{
          display:inline-block;
          max-width: 80px;
          word-wrap:break-word;
          white-space:normal;
        }
        .tag-content {
          span {
            margin-bottom: 8px;
          }
        }
      }
    }
  }
  .tab {
    padding: 16px;
    padding-top: 40px;
    .description {
      border-radius: 12px;
      overflow: hidden;
    }
    .shoip {
      width: 100%;
      table {
        width: 99.5%;
        th {
          text-align: right;
          padding: 12px 0;
          font-weight: 600;
          font-size: 12px !important;
          color: rgba(27, 27, 27, 0.5);
          border-bottom: 1px solid #ebeef5;
        }
        .shipping-text {
          text-align: left;
          padding-left: 30px;
        }
        tbody {
          background-color: hsla(0, 0%, 63.5%, 0.04);
          tr {
            border-bottom: 1px solid #ebeef5;
            border-left: 1px solid #ebeef5;
            border-right: 1px solid #ebeef5;
            cursor: pointer;
            &:hover {
              background: white;
            }
            td {
              padding: 12px 0;
              color: #1b1b1b;
              vertical-align: middle;
            }
            .shipping-country {
              font-weight: 500;
            }
            .shipping-price {
              text-align: right;
              padding-right: 30px;
            }
          }
        }
      }
    }
    .variants {
      .title-top {
        font-size: 14px;
        font-weight: bold;
        color: #949494;
      }
      .title-btn {
        font-size: 12px;
        color: #949494;
        margin-top: 4px;
      }
      .v-title {
        position: relative;
        .title-right {
          font-size: 12px;
          color: #949494;
          position: absolute;
          bottom: 0;
          right: 0;
        }
      }
      .v-list {
        border: 1px solid #ebeef5;
        margin-top: 5px;
        height: 50px;
        overflow: hidden;
        p {
          margin: 0;
        }
        &.active {
          height: auto;
        }
        .v-head {
          cursor: pointer;
          box-sizing: border-box;
          position: relative;
          padding: 0 25px;
          border-bottom: 1px solid #ebeef5;
          &:hover {
            background: #eaeef1;
          }
          .v-head-left {
            float: left;
          }
          .v-head-right {
            float: right;
            text-align: right;
          }
          .title-top {
            margin-top: 10px;
          }
          .title-btn {
            margin-bottom: 10px;
          }
          .title-price {
            font-size: 24px;
            font-weight: bold;
            float: right;
            line-height: 48px;
          }
          .el-icon-arrow-down {
            float: right;
            line-height: 48px;
            margin-left: 30px;
          }
        }
        .v-td {
          padding-bottom: 20px;
          p {
            font-size: 12px;
            height: 30px;
            line-height: 30px;
            padding: 0 45px;
          }
          .v-td-list {
            margin: 0 25px;
            border: 1px solid #ebeef5;
            > div {
              padding: 10px;
              background-color: hsla(0, 0%, 63.5%, 0.04);
              border-bottom: 1px solid #ebeef5;
              cursor: pointer;
              span {
                font-size: 14px;
                float: left;
              }
              em {
                float: right;
                font-style: normal;
                font-weight: bold;
              }
              &:hover {
                background-color: white;
              }
            }
          }
        }
      }
    }
  }
}
</style>
